// extracted by mini-css-extract-plugin
export default {"todolist-header-outer":"styles_todolist-header-outer__bTS7Y","todolist-header":"styles_todolist-header__BCBLs"};